export default __webpack_public_path__ + "static/media/mw_jack_5.773a9287.png";